import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { PaymentMethod, PaymentMethodType } from 'api/common/constants'
import { PositionSimplified } from 'api/common/types'
import Footer from 'components/Footer'
import Header from 'components/Header'
import InputRadio, { InputRadioItem } from 'components/InputRadio'
import loginData from 'utilities/loginData'
import { PositionInfo } from 'utilities/resources/formItemValues'

type StateValue = {
  contractPositions?: PositionSimplified[]
  showPositions?: PositionInfo[]
  previousScene?: PaymentMethodType
}

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const stateValue = React.useMemo(() => (location.state ?? {}) as StateValue, [location])
  const { contractPositions, showPositions, previousScene } = stateValue
  const [selectedPayment, setSelectedPayment] = React.useState<string>(`${PaymentMethod.BankTransfer}`)
  const selectablePayments: InputRadioItem[] = [
    {
      label: '銀行振込',
      value: `${PaymentMethod.BankTransfer}`,
    },
    {
      label: 'クレジットカード',
      value: `${PaymentMethod.CreditCard}`,
    },
  ]

  /**
   * 「お申込みへ」ボタン
   */
  const handleApply = () => {
    switch (selectedPayment) {
      case `${PaymentMethod.BankTransfer}`:
        navigate('/aubeQuestDealPurchaseForBankTransfer', { state: { contractPositions, showPositions } })
        break
      case `${PaymentMethod.CreditCard}`:
        navigate('/aubeQuestDealPurchaseForCreditCard', { state: { contractPositions, showPositions } })
        break
    }
  }

  /**
   * 「戻る」ボタン
   */
  const handleBack = () => {
    switch (previousScene) {
      case PaymentMethod.CreditCard: {
        navigate('/aubeQuestDealPurchaseForCreditCard', { state: { contractPositions, showPositions } })
        break
      }
      default: {
        navigate('/aubeQuestDealPurchaseForBankTransfer', { state: { contractPositions, showPositions } })
        break
      }
    }
  }

  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else if (!contractPositions) {
      navigate('/positionContract')
    }
  }, [navigate, contractPositions])
  return (
    <>
      <Header title="支払い方法選択" />
      <main>
        <section className="mx-4 my-5">
          <div>支払い方法を選んでください。</div>
          <div className="mt-4">
            <InputRadio name="position" label="支払い方法" items={selectablePayments} defaultCheckedValue={selectedPayment} bold setValue={setSelectedPayment} />
          </div>
          <div className="mt-4">現在、一部のクレジットカードおよび一部のプリペイドカードについてはご利用いただけない可能性がございます。</div>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" onClick={handleApply}>
              お申込みへ
            </Button>
          </div>
          <div className="mt-5 text-center">
            <Button variant="link" onClick={handleBack}>
              戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
